import ImageMosaicItem from './ImageMosaicItem';

export default ImageMosaicItem;
